<div class="flex flex-col flex-auto w-full ">
  <div class="p-4 bg-card shadow rounded-lg rounded-md rounded-sm rounded-xl my-4">
    <div class="ttl">Frequently Asked Questions</div>
    <mat-divider></mat-divider>
    <div class="container my-4">
      <mat-form-field style="width: 60% !important; margin: 0px auto; display: block;">
        <mat-icon matSuffix [svgIcon]="'heroicons_outline:search'"></mat-icon>
        <input
          matInput
          style="padding-left:7px"
          [autocomplete]="'off'"
          [placeholder]="'input search text'"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearch()"
        >
      </mat-form-field>
    </div>
    <div *ngFor="let g of filteredFaqsList">
      <h3 class="hedtxt">{{g.fq_grp_nm}}</h3>
      <div style="border-bottom: 1px solid #00000008;" *ngFor="let q of g.questions">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{q.fq_tx}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p style="text-align:justify">{{q.fq_answr_tx}}</p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>

  <!-- <div class="flex flex-wrap mb-2 mt-2">
    
      
    <div class="container">
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> What are municipal fines?</h2>
          <p class="answer"><strong>Ans:</strong> Municipal fines are penalties imposed by the local government for violations of municipal codes and regulations.</p>
      </mat-card>
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> How can I pay my municipal fines?</h2>
          <p class="answer"><strong>Ans:</strong> You can pay municipal fines online through the municipal website, by mail, or in person at the municipal office.</p>
        </mat-card>
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> What are user charges?</h2>
          <p class="answer"><strong>Ans:</strong> User charges are fees imposed on residents for the use of specific municipal services, such as water, sewage, and waste management.</p>
        </mat-card>
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> How are user charges calculated?</h2>
          <p class="answer"><strong>Ans:</strong> User charges are typically calculated based on the usage of the service, such as the amount of water consumed or waste generated.</p>
        </mat-card>
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> What is C & D waste?</h2>
          <p class="answer"><strong>Ans:</strong> C & D waste stands for Construction and Demolition waste, which includes debris generated during the construction, renovation, and demolition of buildings.</p>
        </mat-card>
      <mat-card class="faq-card">
          <h2 class="question"><strong>Q:</strong> How do I dispose of C & D waste?</h2>
          <p class="answer"><strong>Ans:</strong> C & D waste should be disposed of at designated facilities or through services provided by the municipality for safe and proper disposal.</p>
        </mat-card>
  </div> -->